import type { RegionMiniEntity } from "@/features/region/domain/entities/RegionMiniEntity"
import type { Language } from "@/shared/entities/Language"
import type { Gender } from "@/shared/enums/genderEnum"

export class CreateUpdateUserEntity {
  displayName?: string
  phoneNumber?: string
  gender?: Gender
  disabled?: boolean
  language?: Language
  regions?: RegionMiniEntity[]
  password?: string
}
